import { SetupDashboardContext } from '@40seas/frontend/libs/contexts';
import { SetupDashboard, SetupModal } from '@40seas/frontend/libs/entities';
import { useContext } from 'react';
import { useSetupModal } from './useSetupModal';

export function useSetupData(): SetupDashboard | SetupModal {
    const setup = useContext(SetupDashboardContext);

    if (!setup) {
        const modalSetup = useSetupModal();
        if (!modalSetup) throw new Error('SetupDashboard context not initialized!');
        return modalSetup;
    }

    return setup;
}
